<template>
  <div>
    <h3 style="text-align: center;"><b>BÁO CÁO BIẾN ĐỘNG NHÂN SỰ</b></h3>
    <h4 style="text-align: center;">
      từ ngày {{ fromDateBienDong | moment("DD/MM/YYYY") }} đến ngày
      {{ toDateBienDong | moment("DD/MM/YYYY") }}
    </h4>
    <b-table
      id="my-table"
      bordered
      head-variant="dark"
      hover
      striped
      responsive
      small
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template #cell(STT)="data">
        {{ data.index + 1 }}
      </template>
      <!-- <template v-slot:cell(ngaysinh)="data">{{
        formatDate(data.value)
      }}</template> -->
      <template v-slot:cell(ngayhieuluc)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(ngayhethan)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(ngayvaonganh)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(ngaynghiviec)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(loaihopdong)="data">
        <b-badge variant="success" v-if="data.value == 'Chính thức'">
          {{ findTypeOfContract(data.value) }}</b-badge
        >
        <b-badge variant="primary" v-else-if="data.value == 'Thực tập'">{{
          findTypeOfContract(data.value)
        }}</b-badge>
        <b-badge variant="warning" v-else-if="data.value == 'Thử việc'">{{
          findTypeOfContract(data.value)
        }}</b-badge>
        <b-badge variant="info" v-else>{{ data.value }}</b-badge>
      </template>
      <template v-slot:cell(tinhtranghopdong)="data">
        <b-badge variant="success" v-if="data.value == 'Ký mới HĐLĐ'">
          {{ data.value }}</b-badge
        >
        <b-badge variant="warning" v-else-if="data.value == 'Quá hạn'">{{
          data.value
        }}</b-badge>
        <b-badge variant="info" v-else>{{ data.value }}</b-badge>
      </template>
    </b-table>
    <b-badge variant="light">Tổng số: {{ totalRow }}</b-badge>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Report4",
  props: ["fromDateBienDong", "toDateBienDong", "status"],
  data() {
    return {
      fields: [
        {
          key: "STT",
          label: "STT",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "manhanvien",
          label: "Mã NV",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
          // stickyColumn: true,
        },
        {
          key: "hovaten",
          label: "Họ và tên",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        // {
        //   key: "gioitinh",
        //   label: "Giới tính",
        //   sortable: true,
        //   thClass: "text-center",
        // },
        // {
        //   key: "ngaysinh",
        //   label: "Ngày sinh",
        //   sortable: true,
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        {
          key: "vitricongviec",
          label: "Vị trí công việc",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "donvicongtacshort",
          label: "Đơn vị công tác",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
          tdClass: "text-center",
        },
        // {
        //   key: "phongbancongtacshort",
        //   label: "Phòng ban",
        //   sortable: true,
        //   thClass: "text-center",
        //   thStyle: {width: "130px"},
        // },
        {
          key: "ngayvaonganh",
          label: "Ngày bắt đầu làm việc",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
          tdClass: "text-center",
        },
        {
          key: "ngaynghiviec",
          label: "Ngày nghỉ việc",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
          tdClass: "text-center",
        },
        // {
        //   key: "ngayhieuluc",
        //   label: "Ngày hiệu lực",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {textAlign : "center"},
        //   tdClass: "text-center",
        // },
        // {
        //   key: "ngayhethan",
        //   label: "Ngày hết hạn",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {textAlign : "center"},
        //   tdClass: "text-center",
        //},
        // {
        //   key: "tiepnhan",
        //   label: "Tiếp nhận",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {textAlign : "center"},
        // },
        {
          key: "loaihopdong",
          label: "Loại HĐ",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "85px", textAlign: "center" },
        },
        {
          key: "tinhtranghopdong",
          label: "Tình trạng HĐ",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "105px", textAlign: "center" },
        },
        // {
        //   key: "email",
        //   label: "Email",
        //   sortable: true,
        //   thClass: "text-center",
        // },
        // {
        //   key: "tinhtranghoso",
        //   label: "Tình trạng",
        //   sortable: true,
        //   thClass: "text-center",
        // },
      ],
      items: [],
      totalRow: 0,
    };
  },
  // computed: {},
  // beforeRouteEnter(to, from, next) {
  //   let query = Object.assign({}, this.$route.query);
  //     query.report = 1;
  //     axios
  //       .get("/api/employeereport/get", { params: query })
  //       // .get(`/api/employee`, { params: query })
  //       .then((response) => {
  //         this.items = response.data.items;
  //       })
  //       .catch((err) => {});
  // },
  //   beforeRouteUpdate(to, from, next) {

  //   },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let query = Object.assign({}, this.$route.query);
      query.report = 4;
      query.fromDate = this.fromDateBienDong;
      query.toDate = this.toDateBienDong;
      query.status = this.status;
      axios
        .get(`/api/employeereport/get`, { params: query })
        .then((response) => {
          this.items = response.data.items;
          this.totalRow = response.data.totalRow;
        })
        .catch((err) => {});
    },
    findTypeOfContract(type) {
      switch (type) {
        case "Thực tập":
          type = "Intern";
          break;
        case "Thử việc":
          type = "probation";
          break;
        case "Chính thức":
          type = "Official";
          break;
      }
      return type;
    },
    findContractStatus(status) {
      switch (status) {
        case "Ký mới HĐLĐ":
          status = "New signature";
          break;
        case "Quá hạn":
          status = "Overdue";
          break;
      }
      return status;
    },
    formatDate(value) {
      if (!value) return "";
      return this.$moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
